import React, { useState, useEffect } from "react";
import Modals from '../Modals/index';
import { Button, Image, Form, Input } from "@arco-design/web-react";
import './index.less'
import { CommModalProps } from '../enum'
const FormModal = (props: CommModalProps) => {
  const { title, visible, width = 486, style, handCancel, submitHandle, children, icon, showFooter = true, loading = false, subTitle = '确定'  } = props;
  return (
    <Modals
      width={width}
      title={title}
      style={style}
      showFooter={showFooter}
      handleCancel={() => { handCancel(!visible) }}
      cancelBtn={
        <Button
          style={{ marginRight: '10px' }}
          onClick={
            () => {
              if (handCancel) handCancel(!visible);
            }
          }>
          取消
        </Button>
      }
      subMiteBtn={
        <Button
          loading={loading}
          type="primary"
          onClick={() => {
            submitHandle();
          }}>
          {subTitle}
        </Button>
      }
      titleIcon={
        icon && <Image width={18} preview={false} src={icon} />
      }
      visible={visible}>
      { children }
    </Modals>
  );
}

export default FormModal;
